export const dhConfigGassHvisForFp = {
  "Controller": {
    "Name": "EXPO_TileExt"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_GASS_HVIS/list",
      "cache_busting": true
    },
    // "level": {
    //   "Type":"JSON",
    //   "url" : "%expo_tile_gpv_url%/WNI_SRF_VSCAL_GASS_HVIS/level_value",
    //   "cache_busting": true
    // },
    "grayscale_value": {"0": "x", "1": 100, "2": 200, "3": 300, "4": 400, "5": 500, "6": 600, "7": 700, "8": 800, "9": 900, "10": 1000, "11": 1100, "12": 1200, "13": 1300, "14": 1400, "15": 1500, "16": 1600, "17": 1700, "18": 1800, "19": 1900, "20": 2000, "21": 2100, "22": 2200, "23": 2300, "24": 2400, "25": 2500, "26": 2600, "27": 2700, "28": 2800, "29": 2900, "30": 3000, "31": 3100, "32": 3200, "33": 3300, "34": 3400, "35": 3500, "36": 3600, "37": 3700, "38": 3800, "39": 3900, "40": 4000, "41": 4100, "42": 4200, "43": 4300, "44": 4400, "45": 4500, "46": 4600, "47": 4700, "48": 4800, "49": 4900, "50": 5000, "51": 5100, "52": 5200, "53": 5300, "54": 5400, "55": 5500, "56": 5600, "57": 5700, "58": 5800, "59": 5900, "60": 6000, "61": 6100, "62": 6200, "63": 6300, "64": 6400, "65": 6500, "66": 6600, "67": 6700, "68": 6800, "69": 6900, "70": 7000, "71": 7100, "72": 7200, "73": 7300, "74": 7400, "75": 7500, "76": 7600, "77": 7700, "78": 7800, "79": 7900, "80": 8000, "81": 8100, "82": 8200, "83": 8300, "84": 8400, "85": 8500, "86": 8600, "87": 8700, "88": 8800, "89": 8900, "90": 9000, "91": 10000},
    "data": {
      "Type": "TMS",
      "Name": "GASS_HVIS",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_GASS_HVIS_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true
    }
  }
};

export const dhConfigGassClingForFp = {
  "Controller": {
    "Name": "EXPO_TileExt"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_GASS_CLING/list",
      "cache_busting": true
    },
    "grayscale_value": {
      "0": "x",
      "1": 0,
      "2": 328.1,
      "3": 656.2,
      "4": 984.3,
      "5": 1312.4,
      "6": 1640.5,
      "7": 1968.6,
      "8": 2296.7,
      "9": 2624.8,
      "10": 2952.9,
      "11": 3281,
      "12": 3609.1,
      "13": 3937.2,
      "14": 4265.3,
      "15": 4593.4,
      "16": 4921.5,
      "17": 5249.6,
      "18": 5577.7,
      "19": 5905.8,
      "20": 6233.9,
      "21": 6562,
      "22": 6890.1,
      "23": 7218.2,
      "24": 7546.3,
      "25": 7874.4,
      "26": 8202.5,
      "27": 8530.6,
      "28": 8858.7,
      "29": 9186.8,
      "30": 9514.9,
      "31": 9843,
      "32": 10171.1,
      "33": 10499.2,
      "34": 10827.3,
      "35": 11155.4,
      "36": 11483.5,
      "37": 11811.6,
      "38": 12139.7,
      "39": 12467.8,
      "40": 12795.9,
      "41": 13124,
      "42": 13452.1,
      "43": 13780.2,
      "44": 14108.3,
      "45": 14436.4,
      "46": 14764.5,
      "47": 15092.6,
      "48": 15420.7,
      "49": 15748.8,
      "50": 16076.9,
      "51": 16405,
      "52": 16733.1,
      "53": 17061.2,
      "54": 17389.3,
      "55": 17717.4,
      "56": 18045.5,
      "57": 18373.6,
      "58": 18701.7,
      "59": 19029.8,
      "60": 19357.9,
      "61": 19686,
      "62": 20014.1,
      "63": 20342.2,
      "64": 20670.3,
      "65": 20998.4,
      "66": 21326.5,
      "67": 21654.6,
      "68": 21982.7,
      "69": 22310.8,
      "70": 22638.9,
      "71": 22967,
      "72": 23295.1,
      "73": 23623.2,
      "74": 23951.3,
      "75": 24279.4,
      "76": 24607.5,
      "77": 24935.6,
      "78": 25263.7,
      "79": 25591.8,
      "80": 25919.9,
      "81": 26248,
      "82": 26576.1,
      "83": 26904.2,
      "84": 27232.3,
      "85": 27560.4,
      "86": 27888.5,
      "87": 28216.6,
      "88": 28544.7,
      "89": 28872.8,
      "90": 29200.9,
      "91": 29529,
      "92": 29857.1,
      "93": 30185.2,
      "94": 30513.3,
      "95": 30841.4,
      "96": 31169.5,
      "97": 31497.6,
      "98": 31825.7,
      "99": 32153.8,
      "100": 32481.9,
      "101": 32810,
      "102": 33138.1,
      "103": 33466.2,
      "104": 33794.3,
      "105": 34122.4,
      "106": 34450.5,
      "107": 34778.6,
      "108": 35106.7,
      "109": 35434.8,
      "110": 35762.9,
      "111": 36091,
      "112": 36419.1,
      "113": 36747.2,
      "114": 37075.3,
      "115": 37403.4,
      "116": 37731.5,
      "117": 38059.6,
      "118": 38387.7,
      "119": 38715.8,
      "120": 39043.9,
      "121": 39372,
      "122": 39700.1,
      "123": 40028.2,
      "124": 40356.3,
      "125": 40684.4,
      "126": 41012.5,
      "127": 41340.6,
      "128": 41668.7,
      "129": 41996.8,
      "130": 42324.9,
      "131": 42653,
      "132": 42981.1,
      "133": 43309.2,
      "134": 43637.3,
      "135": 43965.4,
      "136": 44293.5,
      "137": 44621.6,
      "138": 44949.7,
      "139": 45277.8,
      "140": 45605.9,
      "141": 45934,
      "142": 46262.1,
      "143": 46590.2,
      "144": 46918.3,
      "145": 47246.4,
      "146": 47574.5,
      "147": 47902.6,
      "148": 48230.7,
      "149": 48558.8,
      "150": 48886.9,
      "151": 49215,
      "152": 49543.1,
      "153": 49871.2,
      "154": 50199.3,
      "155": 50527.4,
      "156": 50855.5,
      "157": 51183.6,
      "158": 51511.7,
      "159": 51839.8,
      "160": 52167.9,
      "161": 52496,
      "162": 52824.1,
      "163": 53152.2,
      "164": 53480.3,
      "165": 53808.4,
      "166": 54136.5,
      "167": 54464.6,
      "168": 54792.7,
      "169": 55120.8,
      "170": 55448.9,
      "171": 55777,
      "172": 56105.1,
      "173": 56433.2,
      "174": 56761.3,
      "175": 57089.4,
      "176": 57417.5,
      "177": 57745.6,
      "178": 58073.7,
      "179": 58401.8,
      "180": 58729.9,
      "181": 59058,
      "182": 59386.1,
      "183": 59714.2,
      "184": 60042.3,
      "185": 60370.4,
      "186": 60698.5,
      "187": 61026.6,
      "188": 61354.7,
      "189": 61682.8,
      "190": 62010.9,
      "191": 62339,
      "192": 62667.1,
      "193": 62995.2,
      "194": 63323.3,
      "195": 63651.4,
      "196": 63979.5,
      "197": 64307.6,
      "198": 64635.7,
      "199": 64963.8,
      "200": 65291.9,
      "201": 65620
    },
    "data": {
      "Type": "TMS",
      "Name": "GASS_CLING",
      "url": "%expo_tile_gpv_url%/WNI_SRF_VSCAL_GASS_CLING_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 5,
        "YCoordinate": -1,
        "BoundingBox": {
          "West": 120,
          "South": 22,
          "East": 150,
          "North": 48
        }
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true
    }
  }
};
